import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const ADD_ARTICLE = createActionType("ADD_ARTICL");
export const GET_ARTICLES = createActionType("GET_ARTICLES");
export const GET_ARTICLE_BY_ID = createActionType("GET_ARTICLE_BY_ID");
export const EDIT_ARTICLE = createActionType("EDIT_ARTICLE");
export const REMOVE_ARTICLE = createActionType("REMOVE_ARTICLE");

export const addArticle = (data: any) =>
  createAsyncAction(ADD_ARTICLE, "/article/add_article", "post", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const getArticles = () =>
  createAsyncAction(
    GET_ARTICLES,
    "/article/get_articles/cpanel",
    "get",
    undefined
  );

export const getArticleById = (data: any) =>
  createAsyncAction(
    GET_ARTICLE_BY_ID,
    `/article/get_article_by_id/${data}`,
    "get",
    undefined
  );

export const editArticle = (id: any, data: any) =>
  createAsyncAction(EDIT_ARTICLE, `/article/edit_article/${id}`, "put", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const removeArticle = (data: any) =>
  createAsyncAction(
    REMOVE_ARTICLE,
    `/article/remove_article_by_id/${data}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
